import { render, staticRenderFns } from "./DisplayGraph.vue?vue&type=template&id=163c754b"
import script from "./DisplayGraph.vue?vue&type=script&lang=ts"
export * from "./DisplayGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports